// Shared look for the Import Wizard: reuses the app-wide Beacon design tokens
// (web/src/styles/beacon-tokens.css) plus the violet "AI-assisted" accent the
// Knowledge Bank page already uses for marketplace/AI badges.
export const W = {
  ink: "var(--color-ink)",
  ink2: "rgba(31,22,51,0.75)",
  ink3: "rgba(31,22,51,0.6)",
  ink4: "rgba(31,22,51,0.5)",
  line: "var(--color-hairline-cloud)",
  lineCool: "var(--color-hairline-cool)",
  surface: "var(--color-surface-canvas-light)",
  surface2: "var(--color-surface-press-light)",
  primary: "var(--color-primary)",
  success: "var(--color-success)",
  successBg: "var(--color-success-bg)",
  warn: "var(--color-warn)",
  warnBg: "var(--color-warn-bg)",
  danger: "var(--color-danger)",
  dangerBg: "var(--color-danger-bg)",
  ai: "var(--color-accent-violet)",
  aiBg: "color-mix(in oklch, var(--color-accent-violet) 9%, white)",
  aiLine: "color-mix(in oklch, var(--color-accent-violet) 30%, white)",
  shadowSm: "var(--shadow-card-sm)",
  shadowMd: "var(--shadow-card-md)",
};

export const STEP_ORDER = {
  ai: ["pick", "scan", "review"],
  document: ["pick", "upload"],
};
